<template>
  <div class="assign_order">
    <div class="assign_form">
      <div class="input-group select2-plugin">
        <select class="form-control select2" v-model="idUsuario" ref="slUsuarios" style="width:100%;" placeholder="Buscar por nombre" data-select2-container="select-sm">
          <option></option>
          <template v-for="user in usuariosCombo">
            <option v-if="user.tienePedido" disabled="disabled" :value="user._id" :key="user._id" :tienePedido="user.tienePedido">{{user.displayName}}</option>
            <option v-else :value="user._id" :key="user._id" :tienePedido="user.tienePedido">{{user.displayName}}</option>
          </template >
        </select>
        <span class="input-group-btn">
          <button class="btn btn-fill" @click.prevent="asignarPlato" type="button">OK</button>
        </span>
      </div>
    </div>
    <a href="#" class="btn btn-default assign_trigger" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="Asignar personas a este plato">
      <i class="fa fa-user-circle"></i>
    </a>
  </div>
</template>
<script>
  import './../../assets/css/select2.css'
  import $ from 'jquery'
  import 'select2'
  import moment from 'moment'

  export default {
    props: {
      admin: {
        type: Object,
        default: () => {}
      },
      usuarios: {
        type: Array,
        default: () => {
          return []
        }
      },
      exclusiones: {
        type: Array,
        default: () => []
      },
      fecha: {
        type: String,
        default: () => ''
      },
      plato: {
        type: Object,
        default: () => {}
      },
      combo: {
        type: String,
        default: () => null
      }
    },
    computed: {
      usuariosCombo () {
        console.log('usuariosCombo')
        const me = this
        let idsExclusiones = me.exclusiones.map((asignacion) => {
          return asignacion.idEmpleado
        })
        let usuarios = me.usuarios.filter((usuario) => {
          if (usuario.roles[0] === 'admincliente') {
            return true
          } else {
            let tienePedido = usuario.pedidos.find((pedido) => {
              const fechaPedido = moment(new Date(pedido.fechaEntrega)).format('DD-MM-YYYY')
              const fechaActual = moment(new Date(me.fecha)).utc().format('DD-MM-YYYY')
              return fechaPedido === fechaActual && me.combo === pedido.combo
            })
            usuario.tienePedido = tienePedido
          }
          return !idsExclusiones.includes(usuario._id)
        })
        usuarios.forEach((usuario) => {
          usuario.id = usuario._id
          usuario.text = usuario.displayName
          usuario.disabled = !!usuario.tienePedido
        })
        console.log('usuarios', usuarios)
        return usuarios
      }
    },
    data () {
      return {
        idUsuario: null
      }
    },
    methods: {
      asignarPlato () {
        // console.log('Asignar plato', this.plato, this.idUsuario, this.fecha)
        this.$emit('select-empleado', {
          idEmpleado: this.idUsuario,
          fecha: this.fecha,
          plato: this.plato
        })
      },
      activarCombo () {
        console.log('activarCombo')
        const me = this
        $(me.$refs.slUsuarios).select2({
          placeholder: 'Seleccione un usuario',
          templateResult: me.formatearCombo
        }).on('change', (e) => {
          me.idUsuario = e.target.value
        })
      },
      formatearCombo (state) {
        // console.log('state', state)
        const me = this
        if (!state.id) {
          return state.text
        }
        let html = `<span>${state.text}</span>`
        let usuario = me.usuarios.find((usuario) => {
          return usuario._id === state.id
        })
        if (usuario.tienePedido) {
          html += ` <span class="label label-danger">tiene pedido</span>`
        }
        return $(html)
      }
    },
    mounted () {
      this.activarCombo()
      $(this.$refs.slUsuarios).val(this.admin._id).trigger('change')
    },
    updated () {
      this.activarCombo()
    }
  }
</script>



// WEBPACK FOOTER //
// ComboAsignarPlato.vue?516d53e6